import {CmsLangBmls} from '@ox/typings';

export const CmsPDPMap: CmsLangBmls = {
  en: {
    chevrolet: 300,
    cadillac: 302,
    buick: 301,
    gm: 304,
    gmc: 303
  }
} as const;
